/**
 * Accessibility enhancements:
 * 1) Iframe accessible names: copy title to aria-label so iframe names are announced (NVDA etc.).
 * 2) New-window links (WCAG F22): add aria-describedby so "Opens in a new window" is announced for target="_blank" links.
 */
(function () {
  var newWindowMessageId = 'a11y-new-window-message';

  function setIframeAccessibleNames() {
    document.querySelectorAll('iframe[title]:not([aria-label])').forEach(function (iframe) {
      var title = iframe.getAttribute('title');
      if (title && title.trim()) {
        iframe.setAttribute('aria-label', title.trim());
      }
    });
  }

  function setNewWindowLinkWarnings() {
    if (!document.getElementById(newWindowMessageId)) return;
    document.querySelectorAll('a[target="_blank"]:not([aria-describedby*="' + newWindowMessageId + '"])').forEach(function (link) {
      var existing = link.getAttribute('aria-describedby') || '';
      link.setAttribute('aria-describedby', (existing + ' ' + newWindowMessageId).trim());
    });
  }

  function run() {
    setIframeAccessibleNames();
    setNewWindowLinkWarnings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  setTimeout(setIframeAccessibleNames, 2000);
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(run, { timeout: 5000 });
  }
})();
